/**
 *
 * @author jpardal
 */
export class ImagenDataDTO {
    id: string = "";
    source_url: string = "";
}
